import React from 'react';
import { MapPin } from 'lucide-react';

/**
 * Секция для выбора региона (отображается, если выбрана опция учета региональных доплат)
 */
const RegionalBonusesSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  russianRegions
}) => {
  return (
    <div className="mb-6 bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-lg border border-indigo-100 dark:border-indigo-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-indigo-500" />
        Региональные доплаты
      </h3>
      
      <div className="mb-4">
        <label htmlFor="region" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Выберите ваш регион
        </label>
        <select
          id="region"
          name="region"
          value={formData.region}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.region ? 'input-error' : ''}`}
        >
          {russianRegions.map((region) => (
            <option key={region.id} value={region.id}>
              {region.name}
            </option>
          ))}
        </select>
        {errors.region && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.region}
          </p>
        )}
      </div>

      {/* Показываем информацию о выбранном регионе */}
      {formData.region && (
        <div className="bg-white dark:bg-gray-800 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800">
          {(() => {
            const region = russianRegions.find(r => r.id === formData.region);
            if (!region) return null;
            
            return (
              <div className="text-sm">
                <p className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                  {region.name}
                </p>
                <div className="flex items-center mt-1">
                  <MapPin className="w-4 h-4 text-indigo-500 mr-2" />
                  <span className="text-xs text-gray-600 dark:text-gray-400">
                    Минимальная пенсия: <strong>{region.minPension.toLocaleString('ru-RU')} ₽</strong>
                  </span>
                </div>
              </div>
            );
          })()}
        </div>
      )}

      <div className="mt-4 bg-indigo-100 dark:bg-indigo-900/30 p-3 rounded-lg">
        <div className="flex items-start">
          <MapPin className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-indigo-700 dark:text-indigo-300 mb-1">
              О региональных доплатах
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400">
              В каждом регионе России устанавливается свой прожиточный минимум пенсионера (ПМП). 
              Если назначенная пенсия ниже этого минимума, пенсионер имеет право на социальную доплату. 
              В Москве и некоторых других регионах установлены дополнительные надбавки к пенсиям 
              для жителей с определенным стажем проживания в регионе.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionalBonusesSection;